import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RoleDetailsService {
  private role = new BehaviorSubject('DCAD');
  roleCode = this.role.asObservable();

  constructor(private httpclient: HttpClient) {}
  updateRole(val: string) {
    this.role.next(val);
  }

  // getRoles(): Observable<any[]> {
  //   return this.httpclient.get<any[]>('assets/json/role.json')
  // }
}
